class FilterRequest{
  constructor(){
    this.userId=null;
    this.gender = null;
    this.age_From = null;
    this.age_To = null;
    this.pageNumber = 0;
    this.pageSize =0;
    this.religion = null;
    this.cast = null;
    this.annual_Income_From = 0;
    this.annual_Income_To = 0;
    this.state = null;
    this.district = null;
   
  
  }}
  export default FilterRequest;